module.exports = {
  api: {
    baseURL: "https://back-pi-sixvago-g1-c2.herokuapp.com",
  },
};

//"http://107.22.80.135:8080"
